
/**
 * 뉴스 출처 정보
 */
export type ExploreContentItemContentOneOfFivezeroSource = {
  name?: string;
  url?: string;
};
